import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { authOperations } from '../containers/Login/state';
import { LOGIN_ROUTE } from '../containers/Login/routes';

class PrivateRoute extends Component {
    render() {
        return this.props.isAuthenticated ?
            <Route
                label={this.props.label}
                path={this.props.path}
                render={(routeProps) => (<this.props.component
                    label={this.props.label}
                    setLoading={this.props.setLoading}
                    toggleAlert={this.props.toggleAlert}
                    setAlert={this.props.setAlert}
                    {...routeProps}
                />)}
            />
            : (
                <Redirect to={{
                    pathname: LOGIN_ROUTE,
                    state: {
                        from: this.props.location
                    }
                }} />
            )
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.auth.isAuthenticated,
        user: state.auth.account
    }
};

const mapDispatchToProps = {
    logoutUser: authOperations.logoutUser
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);